import { NotificationResponse } from '../types/Notificationtypes';
import api from './api';
import { buildApiHeaders } from '../utilities/configUtils';

export async function fetchNotifications(page: number, isUserNotifcations: boolean): Promise<NotificationResponse> {
  try {
    const headers = await buildApiHeaders();
    const response = await api.get(
      `/Notifications/GetAssetNotifications?page=${page}&isUserNotifcations=${isUserNotifcations}`,
      {
        headers,
      },
    );
    return response.data;
  } catch (error) {
    return {
      values: [],
      id: '',
      dateCreated: '',
    };
  }
}
